import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin"
    viewBox="0 0 30 22"
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke="#000" transform="translate(0 1)">
      <path d="M.681 6.54S5.368.212 14.867.212c9.5 0 13.877 6.328 13.877 6.328M5.72 12.754s2.883-4.3 9.024-4.3c6.142 0 8.997 4.092 8.997 4.092" />
      <circle cx={15} cy={17.846} r={2} />
    </g>
  </svg>
);
const Memo = memo(SvgWifi);
export default Memo;
